import Button from "@ticketingplatform/ui/dist/components/atoms/Button";
import PhoneNumberWithPrefixInputField from "@ticketingplatform/ui/dist/components/atoms/Fields/PhoneNumberWithPrefixInput/PhoneNumberWithPrefixInputField";
import Text from "@ticketingplatform/ui/dist/components/styles/Typography";
import { Box } from "components/styles";
import { FormattedMessage } from "react-intl";
import { UseLoginForm } from "views/Login/types";

const LoginStep1: React.FC<ReturnType<UseLoginForm>> = ({ loading }) => (
  <Box py="1.5625rem">
    <Box mb="1.4375rem">
      <Text
        as="label"
        variant="typo5"
        color="blueDianne"
        fontWeight="semiBold"
        mb=".125rem"
      >
        <FormattedMessage defaultMessage="Phone number" />
      </Text>
      <PhoneNumberWithPrefixInputField
        name="phoneNumber"
        variant="secondary"
        disabled={loading}
      />
    </Box>
    <Button type="submit" $mode="tertiary" width="100%" disabled={loading}>
      <FormattedMessage defaultMessage="Next" />
    </Button>
  </Box>
);

export default LoginStep1;
